module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "left1"
  }, [_c('i', [_vm._v("“A hippie is someone who looks like Tarzan, walks like Jane, and smells like Cheetah.”")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("—Ronald Reagan")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('i', [_vm._v("“Good morning! What we have in mind is breakfast in bed for 400,000.”")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("—Wavy Gravy at Woodstock")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('i', [_vm._v("“We are not about to send American boys nine or ten thousand miles away from home to do what Asian boys ought to be doing for themselves.”")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("—President Lyndon Johnson")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('i', [_vm._v("“There’s a bad moon on the rise.”")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("—Creedence Clearwater Revival")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('i', [_vm._v("“Tin soldiers and Nixon coming … Four dead in Ohio.”")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("—Neil Young’s “Ohio” about Kent State")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7581ff46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm2.vue
// module id = 78
// module chunks = 0